import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import type { DecisionMakerAndLegislativeBody } from '../../../../hooks/dmsWithLegislativeBodies/api';

type Result = ModelHookResult<
	{
		decisionMakersAndLegislativeBodies: DecisionMakerAndLegislativeBody[];
		totalCount: number;
	},
	EmptyObject
>;

export function useDmsWithLegislativeBodiesConnection(): Result {
	const {
		data: {
			petition: {
				dmsWithLegislativeBodiesConnection: { nodes, totalCount },
			},
		},
	} = usePetitionDetailsPageData();

	return {
		data: {
			decisionMakersAndLegislativeBodies: [...nodes],
			totalCount,
		},
		actions: {},
	};
}
